export enum TrackingOperationStatus {
    RECEIVED = 'RECEIVED',
    PROCESSED = 'PROCESSED',
    COMPLETE = 'COMPLETE',
    FAILED = 'FAILED',
    RETRY_EXHAUSTED = 'RETRY_EXHAUSTED',
    INCOMPLETE = 'INCOMPLETE',
}
